import { dark } from '@/components/ui/styled/theme.js'

export const theme = dark
export const DIAGEO_COMPANY_ID = '5c52b822943ad5000656687d'
export const DIAGEO_IRELAND_COMPANY = '60d98787cc5283002f3b2c58'
export const DIAGEO_GB_COMPANY = '00000' //66fbdf7ba032c7001d7f33e8
export const HHG_AGENCY_COMPANY_ID = '66e427a1ba6cb2001d7d8d0d'
export const DEMO_HHG_AGENCY_COMPANY_ID = '6729ac87c9c818001d988a9f'
export const COUNTRY_UK = 'cc0000000000000000000001'
export const COUNTRY_IRELAND = 'cc0000000000000000000002'
export const COUNTRY_NORTHERN_IRELAND = 'cc0000000000000000000003'
export const VENUE_HOME_ID = 'edefe0000000000000000027'
export const GB_COMPANY = '66fbdf7ba032c7001d7f33e8'
export const BRAND_DBA = '6409c4fe95219c00303c95e9'
export const BRAND_DIA = '61e58c83a08df3002f0e664d'
export const DBA_LINK = 'https://forms.office.com/Pages/ResponsePage.aspx?id=n_TD6Kqn60Cu0cBC-E5HNZArJGwmZYxOg1lEX0YQ_RJUQU05QzM2UkVJSU1OUUxQRzNUMEFLWDFHVi4u'
export const DEFAULT_CUSTOMER = {
  UK: {
    _id: '5c9df96e96926a6b3ceb1fa1',
    name: "I don't belong to a group",
  },
  Ireland: {
    _id: 'ccc000000000000000000001',
    name: 'All Ireland',
  },
  NorthernIreland: {
    _id: 'ccc000000000000000000002',
    name: 'All Northern Ireland',
  },
}
export const DEFAULT_WHOLESALER = {
  UK: {
    _id: '5c9dde5cbef2d35bffec0e82',
    name: "I can't find my wholesalers",
  },
  Ireland: {
    _id: 'ddd000000000000000000001',
    name: 'All Ireland',
  },
  NorthernIreland: {
    _id: 'ddd000000000000000000002',
    name: 'All Northern Ireland',
  },
}
export const TEMPLATE_VENUE_ALLOCATION =
  'https://s3.eu-west-2.amazonaws.com/static.uat.experiencethis.co/upload_template_csv/template-venue-allocation.csv'
export const TEMPLATE_REP_ALLOCATION =
  'https://s3.eu-west-2.amazonaws.com/static.uat.experiencethis.co/upload_template_csv/template-rep-allocation.csv'
export const TEMPLATE_TERRITORYALLOCATION =
  'https://s3.eu-west-2.amazonaws.com/static.uat.experiencethis.co/upload_template_csv/template_for_territory_allocation.csv'

const DIGITAL_ASSET_TYPE = 'acd000000000000000000011'
const MOBILE_BAR_ASSET_TYPE = 'acd000000000000000000001'
const OUTDOOR_ASSET_TYPE = 'acd000000000000000000009'
const TRAINING_MODULE_ASSET_TYPE = 'acd000000000000000000012'
export const ASSET = {
  DIGITAL: DIGITAL_ASSET_TYPE,
  MOBILE_BAR: MOBILE_BAR_ASSET_TYPE,
  OUTDOOR: OUTDOOR_ASSET_TYPE,
  TRAINING: TRAINING_MODULE_ASSET_TYPE,
}

export const ETLOGO = 'https://s3.eu-west-2.amazonaws.com/static.uat.experiencethis.co/logos/main_nav/Logo+-+dark+(5).png'


export const IMAGE_BOOKING_FORM = ['67abc5b8bccdc1001d6ed5f9', '6799d42eec3aba001d0f94a4', '67612104431159001ded6851', '671f3d7a2a6617001d6ea837', '67860dde0269f6001dccce2b']

// dev 67c586c9051114001e46c67a
export const kitsBreakDown = ['67c586c9051114001e46c67a', '67b9e12df41f29001d01fde6', '67bc7b04a6cedf0028e8ef31', '67b9c869f41f29001d01c789', '67bcb803f53f56001d00cb30', '67bcb820f53f56001d00cd47', '67bcb833f53f56001d00cfcf', '67c6e59ceaae9a001dd1a6f5', '67c8134beaae9a001dd1cbad', '67c8136aeaae9a001dd1cd85']

export const HandbacksCampain = ['6761100e89ee7b001d8ef3c0', '67612104431159001ded6851', '67d01fca02f948001f8258e5', '67bcb803f53f56001d00cb30']

export const HandbacksCampainLink = 'https://docs.google.com/spreadsheets/d/1fdWMhA1eYgxYKG1wj11ouwpW1a4Xv1MLKh4648wgbwU/edit?gid=1723490560#gid=1723490560'

export const FILE_TYPES = {
  csv: 'text/csv',
  txt: 'text/plain',
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  avi: 'video/x-msvideo',
  mkv: 'video/x-matroska',
  webm: 'video/webm',
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
  ogg: 'audio/ogg',
  json: 'application/json',
  default: 'application/octet-stream',
  tif: 'image/tiff',
  tiff: 'image/tiff',
}
